// UI 설정만 관리한다. 편집 엔진과 HTML 호환 규칙은 editor/ 디렉터리에 둔다.
export const FONT_SIZES = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']

export const FORMAT_BUTTONS = [
  { command: 'undo', label: '실행 취소', text: '취소' },
  { command: 'redo', label: '다시 실행', text: '다시' },
  { command: 'bold', label: '굵게 (Ctrl+B)', text: 'B' },
  { command: 'italic', label: '기울임 (Ctrl+I)', text: 'I' },
  { command: 'underline', label: '밑줄 (Ctrl+U)', text: 'U' },
  { command: 'strike', label: '취소선', text: 'S' },
  { command: 'left', label: '왼쪽 정렬', text: '왼쪽' },
  { command: 'center', label: '가운데 정렬', text: '가운데' },
  { command: 'right', label: '오른쪽 정렬', text: '오른쪽' },
  { command: 'justify', label: '양쪽 정렬', text: '양쪽' },
  { command: 'bullet_list', label: '글머리 기호 목록', text: '글머리' },
  { command: 'ordered_list', label: '번호 목록', text: '번호' },
  { command: 'outdent', label: '내어쓰기', text: '내어쓰기' },
  { command: 'indent', label: '들여쓰기', text: '들여쓰기' },
  { command: 'image', label: '이미지 삽입 및 수정', text: '이미지' },
  { command: 'link', label: '링크 삽입 및 수정', text: '링크' },
  { command: 'removeformat', label: '서식 지우기', text: '서식 지우기' }
]

// 기존 플러그인의 메뉴 기능도 실제 동작하는 명령으로 연결한다.
export const EDITOR_MENUS = [
  { label: '파일', items: [['preview', '미리보기'], ['print', '인쇄']] },
  { label: '편집', items: [['undo', '실행 취소'], ['redo', '다시 실행'], ['selectAll', '전체 선택'], ['search', '찾기 / 바꾸기']] },
  { label: '보기', items: [['code', 'HTML 소스'], ['visualblocks', '블록 경계'], ['fullscreen', '전체 화면']] },
  { label: '삽입', items: [['image', '이미지'], ['link', '링크'], ['unlink', '링크 해제'], ['anchor', '책갈피'], ['media', '동영상 / 오디오'], ['charmap', '특수문자'], ['datetime', '날짜 / 시간'], ['hr', '가로줄'], ['toggle', '접기 / 펼치기']] },
  { label: '서식', items: [['format:p', '본문'], ['format:h1', '제목 1'], ['format:h2', '제목 2'], ['format:h3', '제목 3'], ['format:blockquote', '인용문'], ['format:pre', '코드 블록'], ['subscript', '아래 첨자'], ['superscript', '위 첨자'], ['inlineCode', '인라인 코드'], ['listStyle:disc', '채운 원 글머리'], ['listStyle:circle', '빈 원 글머리'], ['listStyle:square', '사각 글머리'], ['listStyle:decimal', '숫자 목록'], ['listStyle:lower-alpha', '영문 목록'], ['listStyle:upper-roman', '로마 숫자 목록'], ['removeformat', '서식 지우기']] },
  { label: '표', items: [['table', '표 삽입'], ['tableProperties', '표 속성'], ['cellProperties', '셀 속성'], ['addRowBefore', '위에 행 추가'], ['addRowAfter', '아래에 행 추가'], ['deleteRow', '행 삭제'], ['addColumnBefore', '왼쪽에 열 추가'], ['addColumnAfter', '오른쪽에 열 추가'], ['deleteColumn', '열 삭제'], ['mergeCells', '셀 합치기'], ['splitCell', '셀 나누기'], ['toggleHeaderRow', '머리글 행 전환'], ['toggleHeaderColumn', '머리글 열 전환'], ['deleteTable', '표 삭제']] },
  { label: '도움말', items: [['help', '사용 방법 / 단축키']] }
]



// WEBPACK FOOTER //
// ./src/components/ETC/customTextareaConfig.js